import fetch from '../utils/fetch'

export function createRechargeRule (query) {
  return fetch({
    url: '/deposit/rechargerule',
    method: 'post',
    data: query
  })
}

export function getRechargeRuleList (query) {
  return fetch({
    url: '/deposit/rechargerules',
    method: 'get',
    params: query
  })
}

export function deleteRechargeRuleById (id) {
  return fetch({
    url: '/deposit/rechargerule/' + id,
    method: 'delete'
  })
}

export function editRechargeRuleById (query) {
  return fetch({
    url: '/deposit/rechargerule',
    method: 'put',
    params: query
  })
}

export function setRechargeAgreement (query) {
  return fetch({
    url: '/deposit/recharge/agreement',
    method: 'post',
    data: query
  })
}

export function getRechargeAgreementByCompanyId () {
  return fetch({
    url: '/deposit/recharge/agreement',
    method: 'get'
  })
}

export function setRechargeMultiple (query) {
  return fetch({
    url: '/deposit/recharge/multiple',
    method: 'post',
    data: query
  })
}

export function getRechargeMultipleByCompanyId () {
  return fetch({
    url: '/deposit/recharge/multiple',
    method: 'get'
  })
}

export function getDepositTradeList (query) {
  return fetch({
    url: '/deposit/trades',
    method: 'get',
    params: query
  })
}

export function getDepositCountIndex () {
  return fetch({
    url: '/deposit/count/index',
    method: 'get'
  })
}

/*
 *获取用户预存款明细列表
 */
export function getUserDepositList (query) {
  return fetch({
    url: '/members/memberadvance/list',
    method: 'get',
    params: query
  })
}

/*
 *获取用户线下预存款列表
 */
export function getUserNpDepositList (query) {
  return fetch({
    url: '/members/memberadvance/getnplist',
    method: 'get',
    params: query
  })
}
/*
 * 用户预存款余额
 */
export function getUserDeposit (query) {
  return fetch({
    url: '/members/memberadvance/getUserAmount',
    method: 'get',
    params: query
  })
}
/*
 *用户预存款增加减少
 */
export function depositRecharge (query) {
  return fetch({
    url: '/members/memberadvance/depositRecharge',
    method: 'post',
    params: query
  })
}

/*
 * 获取用户预存款充值明细列表
 */
export function getUserRechargeInfo (query) {
  return fetch({
    url: '/members/getRechargeInfo',
    method: 'get',
    params: query
  })
}

/*
 * 用户预存款充值退款
 */
export function userRechargeRefund (query) {
  return fetch({
    url: '/members/rechargeRefund',
    method: 'post',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/deposit.js